import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Button, { ButtonProps } from "@mui/material/Button";
import { alpha, styled } from "@mui/material/styles";
import Chip from "@mui/material/Chip";
import Collapse from "@mui/material/Collapse";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { makeGETRequestOnUserService } from "../../Api/api";
import toastr from "toastr";
import { RouteComponentProps, withRouter, useParams } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import { OrderDetailsInterface } from "../RFQOrders/interfaces";
import { StyledChip } from "../RFQOrders/NewRFQOrderDetails";
import RFQSellActionButtons from "./RFQSellActionButtons";
import RazorpaySellActionButtons from "./RazorpaySellActionButtons";
import DealSellInfoActionButtons from "./DealSellInfoActionButtons";
import DealSellStatus from "./DealSellStatus";
import WebSellhooks from "./WebSellhooks";
import RazorpaySellData from "./RazorpaySellData";
import ClientSellInfo from "./ClientSellInfo";
import DebarredSellInfo from "./DebarredSellInfo";
import SettlementSellInformation from "./SettlementSellInformation";
import RFQSellInfo from "./RFQSellInfo";
import DealProposeSellInfo from "./DealProposeSellInfo";
import DealApproveSellInfo from "./DealApproveSellInfo";
import InvoiceSellInfo from "./InvoiceSellInfo";

const RFQSellOrderDetails: React.FC<RouteComponentProps> = (props) => {
  const [expandRFQButtons, setExpandRFQButtons] = useState(false);
  const [expandRazorpayButtons, setExpandRazorpayButtons] = useState(false);
  const [expandDealInfoButtons, setExpandDealInfoButtons] = useState(false);
  const [dealStatus, setDealStatus] = useState("Pending");
  const [orderDetails, setOrderDetails] =
    useState<OrderDetailsInterface | null>(null);
  const [loading, setLoading] = useState(true);

  const {
    orderUUID,
    type,
  }: {
    orderUUID: string;
    type: string;
  } = useParams();

  useEffect(() => {
    let active = true;
    if (!loading) {
      return undefined;
    }
    let apiUrl = `/order_management_v2/client/order_details/${orderUUID}/`;
    if (type === "partner") {
      apiUrl += "?type=partner";
    } else if (type === "client") {
      apiUrl += "?type=client";
    }
    makeGETRequestOnUserService(apiUrl)
      .then((resp) => {
        if (active && resp.status == 200) {
          setOrderDetails(resp.data);
          setDealStatus(resp.data.deal_status);
        }
      })
      .catch((error) => toastr.error(error))
      .finally(() => {
        active && setLoading(false);
      });
    return () => {
      active = false;
    };
  }, [loading]);

  return (
    <Box sx={{ maxWidth: ["90%", "80%"], mx: "auto", my: 5 }}>
      <Button
        sx={{ mb: 2 }}
        variant="contained"
        startIcon={<ExpandMoreIcon sx={{ rotate: "90deg" }} />}
        href="/rfq_sell_orders"
      >
        View All Orders
      </Button>
      {loading ? (
        <CircularProgress color="error" />
      ) : orderDetails ? (
        <>
          <Box sx={{ bgcolor: "#FFFFFF", p: 2, borderRadius: 5 }}>
            {(JSON.parse(localStorage.getItem("loginUser")!)?.isSuperuser ||
              JSON.parse(localStorage.getItem("loginUser")!)?.can_see_all) && (
                <>
                  <Box sx={{ display: "flex", gap: 2 }}>
                    <StyledChip
                      label="RFQ Actions"
                      onClick={() => {
                        setExpandRFQButtons(!expandRFQButtons);
                        setExpandRazorpayButtons(false);
                        setExpandDealInfoButtons(false);
                      }}
                      expandOrCollapse={expandRFQButtons}
                    />
                    <StyledChip
                      label="Deal Information"
                      onClick={() => {
                        setExpandDealInfoButtons(!expandDealInfoButtons);
                        setExpandRazorpayButtons(false);
                        setExpandRFQButtons(false);
                      }}
                      expandOrCollapse={expandDealInfoButtons}
                    />
                  </Box>
                  <Collapse in={expandRFQButtons}>
                    <RFQSellActionButtons
                      orderDetails={orderDetails}
                      orderUUID={orderUUID}
                      setLoading={setLoading}
                      type={type}
                    />
                  </Collapse>
                  <Collapse in={expandDealInfoButtons}>
                    <DealSellInfoActionButtons
                      orderDetails={orderDetails}
                      orderUUID={orderUUID}
                      props={props}
                      type={type}
                    />
                  </Collapse>
                  <Box
                    component="hr"
                    sx={{ borderColor: "#7659EE", opacity: 0.5, my: 4 }}
                  />
                  <DealSellStatus
                    orderUUID={orderUUID}
                    setLoading={setLoading}
                    dealStatus={dealStatus}
                    setDealStatus={setDealStatus}
                    type={type}
                  />
                </>
              )}
            <WebSellhooks orderDetails={orderDetails} />
          </Box>

          <ClientSellInfo orderDetails={orderDetails} />

          <DebarredSellInfo orderDetails={orderDetails} />

          <SettlementSellInformation orderDetails={orderDetails} />

          <RFQSellInfo orderDetails={orderDetails} />

          <DealProposeSellInfo orderDetails={orderDetails} />

          <DealApproveSellInfo orderDetails={orderDetails} />

          <InvoiceSellInfo />
        </>
      ) : (
        <Typography textAlign="center">
          Error Fetching Order Details, Pls check with backend
        </Typography>
      )}
    </Box>
  );
};

export default withRouter(RFQSellOrderDetails);
